import MicroModal from 'micromodal'; 
import NumberStepper from './number-stepper.js';

// JS PRODUCTS
export function product() {

	console.log('PRODUCT SCRIPT');
	// Els
	const productForm = document.getElementById('AddToCartForm');
	const product = JSON.parse(productForm.querySelector('#js-product').value);
	const optionRadios = Array.prototype.slice.call(productForm.querySelectorAll('[type="radio"]'));
	console.log('OPTIONRADIOS ====>', optionRadios)
	const priceEl = productForm.querySelector('.js-price');
	const productSelect = productForm.querySelector('#productSelect');
	const productRadioWrap = productForm.querySelector('.js-options-wrap');
	const moneyFormat = productForm.querySelector('#js-money-format').value
	const submitBtn = productForm.querySelector('#AddToCart');
	const qtySelect = productForm.querySelector('#Quantity');
	const msgEl = productForm.querySelector('#message');
	const msgText = msgEl.querySelector('#msg-text');
	const cartCount = document.querySelector('#js-cart-count');
	const addToCartBtn = productForm.querySelector('#add-to-cart-btn-text').value;
	const upsellRecommend = document.querySelector('#upsell-recommend');
	const upsellLowCost = document.querySelector('#upsell-low-cost');

	const galleryThumbsWrap = document.querySelector('#product-thumbnails');
	const galleryThumbs = galleryThumbsWrap ? Array.prototype.slice.call(galleryThumbsWrap.querySelectorAll('.thumb button')) : null;

	// Vars
	const variants = product.variants;

	console.log('VARIANTS ======>' , variants);

	const productVariants = variants.map(variant => {
		variant.inventory_quantity = parseInt(document.querySelector(`[name="${variant.id}"]`).value)
		return variant
	});
	console.log('PRODUCT VARIANTS ======>' , productVariants);

	const lowStockThreshold = parseInt(document.getElementById('low-stock-threshold').value);
	const maxQty = parseInt(document.getElementById('max-qty').value);

	const soldOutMsg = document.getElementById('sold-out-msg').value;
	const lowStockMsg = document.getElementById('low-stock-msg').value;
	const notAvailableMsg = document.getElementById('not-available-msg').value;;
	const errorMsg = document.getElementById('error-msg').value;

	const numberStepper = new NumberStepper(document.querySelector('.js-number-stepper'));

	// Modal Upsell Vars
	let currentCartPrice = document.getElementById('js-cart-total').value;
	let freeDeliveryMinThreshold = document.getElementById('js-cart-free-min-threshold').value;
	let freeDeliveryMaxThreshold = document.getElementById('js-cart-free-max-threshold').value;
	let freeDeliveryAmount = document.getElementById('js-cart-free-price').value;
	const deliveryMsgAmountEl = document.querySelector('.js-free-delivery-diff');
	const deliveryMsgEl = document.querySelector('.js-cart-delivery-msg');

	let useModal = true;

	MicroModal.init();

	optionRadios.forEach(radio => {
		radio.addEventListener('change', handleUpdate, false)
	});

	// function to turn off AJAX add to cart - for A/B Test
	window.removeModal = function() {
		useModal = false;
	}

	productForm.addEventListener('submit', handleSubmit);

	function getOptions() {
		let options = [];
		optionRadios.forEach(radio => {
			if (!radio.checked) {
				return;
			}
			options.push(radio.value)

		});

		return options.join(' / ');
	}

	function handleSubmit(e) {
	
		e.preventDefault();

		submitBtn.classList.add('is-loading');
		submitBtn.innerHTML = '&hellip;';

		const properties = productForm.querySelectorAll('input[name*="properties["');
		let propertyObj = {}

		properties.forEach((input) => {
			return propertyObj[input.name.substring(11, input.name.length-1)] = input.value;
		})

		const addData = {
			'items': [{
				id: getVariant(getOptions()).id,
				quantity: parseInt(qtySelect.value),
				properties: propertyObj
			}]
		}

		addToCart(addData);

		
		return;
		
	}

	function getVariant(options) {
		const variant = productVariants.find(variant => variant.title === options);

		return {
			id: variant ? variant.id : null,
			price: variant ? variant.price : null,
			stock: variant ? variant.inventory_quantity : null,
			inventory: variant ? variant.inventory_management : null
		}
	}

	function initRadios() {

		optionRadios.forEach(radio => {
			
			let currentOptGroup = radio.dataset.optionGroup;
			
			let isAvailable = productVariants.findIndex(item => {
				return item[currentOptGroup] == radio.value && item.available == true;
			}) > -1;
			
			
			if (isAvailable) {
				radio.removeAttribute('disabled');
				radio.nextElementSibling.removeAttribute('disabled');
			} else {
				radio.setAttribute('disabled', 'disabled');
				radio.nextElementSibling.setAttribute('disabled', 'disabled');
			}

			return;

		})

		updateUI();
	}

	// Need to run this on inint
	function handleUpdate(e) {

		let currentRadio = e.target;
		let currentRadioVal = currentRadio.value;
		let optGroup = currentRadio.dataset.optionGroup;

		let availableOptions = productVariants.filter(item => {
			return item[optGroup] == currentRadioVal;
		}) 

		console.log('AVAIL OPTS ======> ',availableOptions);

		optionRadios.forEach(radio => {
			let currentOptGroup = radio.dataset.optionGroup;

			if (currentOptGroup === optGroup) {
				return
			} 

			let isAvailable = availableOptions.findIndex(item => {
				return item[currentOptGroup] == radio.value && item.available == true;
			}) > -1;

			if (isAvailable) {
				radio.removeAttribute('disabled');
				radio.nextElementSibling.removeAttribute('disabled');
			} else {
				radio.setAttribute('disabled', 'disabled');
				radio.nextElementSibling.setAttribute('disabled', 'disabled');
			}

			return;


		})

		updateUI();

	}

	function updateUI() {
		const variant = getVariant(getOptions());

		if (!variant.id) {
			return handleUnavailable();
		}

		if (variant.stock === 0 && variant.inventory) {
			return handleSoldOut();
		}

		if ((variant.stock <= lowStockThreshold && variant.inventory) || (variant.stock < maxQty && variant.inventory))  {
			return handleLowStock(variant);
		}

		return handleOk(variant);

	}

	function handleSoldOut() {

		submitBtn.setAttribute('disabled', 'disabled');

		updateMsg(soldOutMsg);

		return

	}
	
	function handleUnavailable() {

		submitBtn.setAttribute('disabled', 'disabled');

		updateMsg(notAvailableMsg);

		return

	}

	function handleLowStock(variant) {

		let msg = lowStockMsg.replace('####', variant.stock)
		// set max range on qty select
		if (variant.stock < maxQty) {
			fillQtySelect(variant.stock);
		} else {
			fillQtySelect(maxQty);
		}

		numberStepper.checkVal();

		// show message
		updateMsg(msg); 

		updateGallery(variant.id)

		return;
	}

	function handleOk(variant) {
		submitBtn.removeAttribute('disabled');
		setPrice(variant);
		// set max range on qty select
		if (variant.stock < maxQty) {
			fillQtySelect(variant.stock);
		} else {
			fillQtySelect(maxQty);
		}

		numberStepper.checkVal();

		hideMsg();

		updateGallery(variant.id)

		return;
	}

	function updateGallery(variantId) {

		if (!galleryThumbsWrap) {
			return;
		} 

		const currentThumb = galleryThumbs.find((thumb) => {
			return thumb.dataset.matchingVariants.includes(variantId);
		});

		if (!currentThumb) {
			return;
		}

		return currentThumb.click();

	}

	function setPrice(variant) {
		priceEl.innerHTML = Shopify.formatMoney(variant.price, moneyFormat);
	}

	function fillQtySelect(num) {
		qtySelect.setAttribute('max', num);
		return;
	} 

	function updateMsg(msg) {
		msgEl.classList.remove('hidden')
		msgText.innerHTML = msg;
		return;
	}

	function hideMsg() {
		msgText.innerHTML = '';
		msgEl.classList.add('hidden');
		return
	}

	function addToCart(items) {
		fetch('/cart/add.js', {

			body: JSON.stringify(items),
			credentials: 'same-origin',
			headers: {
				'Content-Type': 'application/json',
				'X-Requested-With':'xmlhttprequest' /* XMLHttpRequest is ok too, it's case insensitive */
			},
			method: 'POST'
			
		}).then(function(response) {
			
			return response.json();
			
		}).then(function(json) {

			/* we have JSON */
			
			// Shopify error which is not returned as an error 😫
			if (json.status === 422) {
				console.error(json)
				updateMsg(errorMsg)
				submitBtn.classList.remove('is-loading');
				submitBtn.innerHTML = addToCartBtn;
				return
			}
			
			// SUCCESS
			submitBtn.classList.remove('is-loading');
			submitBtn.innerHTML = addToCartBtn;
			updateCartCount()

			if (useModal) {
				MicroModal.show('add-to-cart-modal'); 
			} else {
				window.location.href = '/cart';
			}
			
		}).catch(function(err) {

			/* uh oh, we have a REAL error. */
			
			console.error('add to cart err', err)
			updateMsg(errorMsg);
			submitBtn.classList.remove('is-loading');
			submitBtn.innerHTML = addToCartBtn;

		});
	}

	function updateCartCount() {
		fetch('/cart.json')

		.then(function(response) {

			return response.json();
			
		}).then(function(cart) {

			/* we have JSON */
			
			// Update the desktop and mobile cart counts
			cartCount.innerHTML = cart.item_count
			// UPdate modal
			updateModal(cart);

		}).catch(function(err) {

			/* uh oh, we have error. */
			
			console.error(err);
			updateMsg(errorMsg);

		});
	}

	function updateModal(data) {

		 currentCartPrice = data.total_price;
		 let currentDiff = freeDeliveryAmount - currentCartPrice;

		 if (currentCartPrice >= freeDeliveryMinThreshold && currentCartPrice < freeDeliveryMaxThreshold) {

			deliveryMsgAmountEl.innerHTML = Shopify.formatMoney(currentDiff, moneyFormat);
			deliveryMsgEl.classList.remove('hidden');

		 } else {
			deliveryMsgEl.classList.add('hidden');
		 }

		 if (document.querySelector("#upsell-recommend")) {
			 
			recommend();

			if (upsellLowCost) {
				
				if (currentDiff <= 500 && currentDiff > 0) {
					upsellRecommend.classList.add('hidden');
					upsellLowCost.classList.remove('hidden');
				 } else {
					 upsellRecommend.classList.remove('hidden');
					 upsellLowCost.classList.add('hidden');
				 }

			} else {
				upsellRecommend.classList.remove('hidden');
			}
			
				
		 }

	}

	function recommend() {

		// Find the container that will hold the recommendations
		var list = document.querySelector("#modal-product-upsell");
		// Get the product id to request the product recommendations
		var productId = list.dataset.productId;
	
		const limit = list.dataset.limit;
	
		const wasText = document.querySelector('#was-text').value || '';
		
		Shopify.money_format = list.dataset.moneyFormat;
	
		fetch(`/recommendations/products.json?product_id=${productId}&limit=${limit}`)
	 .then(response => response.json())
	 .then(({ products }) => {
		
			if (products.length === 0) {
				return hideRecommendationsSection();
			}
		
			return products.map((product) => {
				return (async () => {
					return {
						product: product,
						variants: await getSKUs(product)
					}
				})();
			});
			// Append product recommendations to the DOM.
			//return list.innerHTML = products.map(function(product) { return renderProduct(product) }).join("");
		})
		.then(products => {
			return Promise.all(products);
		})
		.then(items => {
			
			let htmlString = items.map(item => {
	
				return renderProduct(item.product, item.variants.join(","))
			}).join("");
			
			return list.innerHTML = htmlString;
		})
		.then(()=> {
			window.lazy.init();
			window.cardScores();
		})
			
			
		function hideRecommendationsSection() {
			list.style.display = "none";
		}
	
		async function getSKUs(product) {
	
			const productData = await fetch(`${Shopify.routes.root}products/${product.handle}.js`)
				.then(response => response.json())
				.then(response => response.variants.map(item => item.sku));
		
				return productData;
		};
			
		function renderProduct(product, variants) {
	
			return `<div class="media modal-product">

			<div class="media__img">
				<figure class="frame frame--1x1">
					<img data-src="${ product.featured_image }" alt="${ product.title }" class="lazy">
				</figure>
			</div>

			<div class="media__body stack stack--s">

				<a class="link link--no-border" href=${ product.url }"><h3 class="h h4">${ product.title }</h3></a>

				<div class="price flex">

					<div class="js-price ${ product.compare_at_price ? `price__sale` : '' }">
						${ Shopify.formatMoney(product.price, window.moneyFormat) }
					</div>

					${ product.compare_at_price ? `	<span class="vh">${wasText}</span><div class="price__was">${Shopify.formatMoney(product.compare_at_price, window.moneyFormat)}</div>` : '' }

				</div>
			</div>
						
		</div>`
		}
	};

	function init() {

		productSelect.classList.add('hidden');
		productRadioWrap.removeAttribute('hidden');

		initRadios();

	}

	init();

}